import type { HttpClient } from '../http/types';
import type { AcceptInvitePayload, AuthSession, CurrentSession, LoginPayload } from '../types/user';
import { ENDPOINTS } from './endpoints';

export function createAuthApi(http: HttpClient) {
  return {
    /** POST /auth/login — e-mail/senha; cria a sessão via cookie __session e responde 204. */
    login: (payload: LoginPayload) =>
      http.post<void>(ENDPOINTS.auth.login, payload, { skipAuth: true }),

    /** Troca o idToken do Firebase pelo cookie de sessão __session (HttpOnly). */
    sessionLogin: (idToken: string) =>
      http.post<void>(ENDPOINTS.auth.sessionLogin, { idToken }, { skipAuth: true }),

    logout: () => http.post<void>(ENDPOINTS.auth.logout),

    me: () => http.get<CurrentSession>(ENDPOINTS.auth.me),

    forgotPassword: (email: string) =>
      http.post<void>(ENDPOINTS.auth.forgotPassword, { email }, { skipAuth: true }),

    resetPassword: (payload: { token: string; password: string }) =>
      http.post<void>(ENDPOINTS.auth.resetPassword, payload, { skipAuth: true }),

    acceptInvite: (payload: AcceptInvitePayload) =>
      http.post<AuthSession>(ENDPOINTS.auth.acceptInvite, payload, { skipAuth: true }),
  };
}

export type AuthApi = ReturnType<typeof createAuthApi>;
